import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

function Contact() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Contact</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">About</Link></li>
            <li class="breadcrumb-item active" aria-current="page">ContactUs</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">About Us</H2>
                  <div className="text-dark-200" style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                      <p>
                        <b>Institute for Big Data Analytics and Artificial Intelligence (IBDAAI)</b><br/>
                        Kompleks Al-Khawarizmi<br/>
                        Universiti Teknologi MARA (UiTM)<br/>
                        40450 Shah Alam, Selangor Darul Ehsan<br/>
                        Malaysia<br/>

                      <br/>E-mail: <a href="mailto:scds2023@uitm.edu.my">scds2023@uitm.edu.my</a>

                      <br/>Tel: +603-5543 5488
                      </p>
                  </div>
              </div>
          </div>

  </div>
    );
}

export default Contact;

// import React from 'react';
// import { Card } from 'react-bootstrap';
// import Helmet from "react-helmet";
// import { Link } from 'react-router-dom';

// import uitm from '../../assets/images/contents/UiTM_main.jpg';

// export const Contact = () => (
//   <div>
//     <Helmet>
//       <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Contact</title>
//     </Helmet>
//     <nav aria-label="breadcrumb">
//       <ol class="breadcrumb">
//         <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
//         <li class="breadcrumb-item"><a href="/">About</a></li>
//         <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
//       </ol>
//     </nav>
//     <h2>Contact Us</h2> <br/>  

    

//     <Card style={{ width: '20rem' }}>
//     <Card.Img variant="top" src={uitm} />
//     <Card.Body>
//       <Card.Title>Institute for Big Data Analytics and Artificial Intelligence<br/></Card.Title>
//       <Card.Text>Kompleks Al-Khawarizmi, Universiti Teknologi MARA, <br/>  
//                   40450 Shah Alam, Selangor, Malaysia</Card.Text>
                 
    
//       <Card.Text>   
//         <address>
//           Email: <a href="mailto:scds2023@uitm.edu.my">scds2023@uitm.edu.my</a>
//         </address> <br/>
//       </Card.Text>
//     </Card.Body>
//   </Card> <br/>
//   </div>
// )